<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        dense
        rounded
        filled
        v-model="searchField"
        prepend-inner-icon="mdi-magnify"
        :label="$t('actions.search-three-dots')"
        single-line
        hide-details
        append-icon="mdi-close"
        @click:append="searchField = ''"
      ></v-text-field>
    </v-col>
    <v-col cols="0" style="display: none;">
      <v-text-field
        dense
        rounded
        filled
        v-model="filter"
        prepend-inner-icon="mdi-filter-outline"
        :label="$t('actions.filter-three-dots')"
        single-line
        hide-details
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PageSearch',
  props: ['search'],
  data () {
    return {
      searchField: '',
      filter: ''
    }
  },
  watch: {
    search (value) {
      this.searchField = value
    },
    searchField () {
      this.$emit('changed', this.searchField)
    },
    filter () {
      this.$emit('filter', this.filter)
    },
  }
}
</script>

<style scoped>

</style>